(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-flavor-carousel';
  var CARD_SELECTOR = '.oddit-section-flavor-carousel__card';
  var CLONE_ATTR = 'data-fc-clone';
  var sectionState = new Map();
  var sectionCounter = 0;

  // Strip reveal state + interactivity from a cloned card so it renders
  // immediately (oddit-reveal would otherwise leave it at opacity:0) and never
  // steals focus or fires duplicate add-to-cart wiring. The oddit-hover-*
  // classes are intentionally KEPT so clones lift/zoom on hover just like the
  // originals — otherwise the duplicated edge cards look "dead" on hover.
  function sanitizeClone(el) {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute(CLONE_ATTR, 'true');
    var nodes = [el].concat(Array.prototype.slice.call(el.querySelectorAll('*')));
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList) {
        var tokens = Array.prototype.slice.call(n.classList);
        for (var j = 0; j < tokens.length; j++) {
          var c = tokens[j];
          if (c.indexOf('oddit-reveal') === 0) {
            n.classList.remove(c);
          }
        }
      }
      if (n.style) {
        n.style.opacity = '';
        n.style.transform = '';
        n.style.transition = '';
      }
      if (n.removeAttribute) {
        n.removeAttribute('data-oddit-stagger');
        if (n.hasAttribute('data-add-to-cart')) n.removeAttribute('data-add-to-cart');
      }
      if (n.matches && n.matches('a, button, input, select, textarea, [tabindex]')) {
        n.setAttribute('tabindex', '-1');
      }
    }
  }

  function initSection(section) {
    if (!section || section.dataset.odditFcInit === 'true') return;
    section.dataset.odditFcInit = 'true';

    var sectionKey = section.id || ('oddit-fc-' + (++sectionCounter));
    if (!section.id) section.id = sectionKey;

    var track = section.querySelector('.oddit-section-flavor-carousel__track');
    if (!track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll(CARD_SELECTOR + ':not([' + CLONE_ATTR + '])')
    );
    var N = originals.length;
    var dots = section.querySelectorAll('.oddit-section-flavor-carousel__dot');
    var prevBtn = section.querySelector('.oddit-section-flavor-carousel__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-flavor-carousel__arrow--next');

    var loop = N > 1;

    var state = {
      currentIndex: 0,
      currentDomIndex: 0,
      slideCount: N,
      realStart: 0,
      autoplay: null,
      programmaticScroll: false,
      userControl: false,
      settleTimer: null,
      cleanup: []
    };

    // ---- Clone the full set on both sides for seamless infinite looping ----
    // Layout becomes: [clones 0..N-1][originals 0..N-1][clones 0..N-1].
    // Real slides live at DOM indices [N, 2N); a clone immediately left of the
    // first real slide is the last slide, and vice versa — so the wrap is
    // visually continuous before we silently reset scrollLeft.
    if (loop) {
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      for (var c = 0; c < N; c++) {
        var before = originals[c].cloneNode(true);
        sanitizeClone(before);
        beforeFrag.appendChild(before);
        var after = originals[c].cloneNode(true);
        sanitizeClone(after);
        afterFrag.appendChild(after);
      }
      track.insertBefore(beforeFrag, originals[0]);
      track.appendChild(afterFrag);
      state.realStart = N;
    }

    var allSlides = track.querySelectorAll(CARD_SELECTOR);

    function getSlideOffset(domIndex) {
      var slide = allSlides[domIndex];
      if (!slide) return 0;
      // Center the slide within the viewport (symmetric bleed on both sides).
      return slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
    }

    function toLogical(domIndex) {
      return ((domIndex - state.realStart) % N + N) % N;
    }

    function nearestDomIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = state.realStart;
      var closestDist = Infinity;
      for (var i = 0; i < allSlides.length; i++) {
        var slideCenter = allSlides[i].offsetLeft + allSlides[i].offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      }
      return closest;
    }

    function setScrollInstant(domIndex) {
      state.programmaticScroll = true;
      track.scrollTo({ left: getSlideOffset(domIndex), behavior: 'auto' });
      state.currentDomIndex = domIndex;
    }

    function smoothScrollToDom(domIndex) {
      state.programmaticScroll = true;
      state.currentDomIndex = domIndex;
      track.scrollTo({ left: getSlideOffset(domIndex), behavior: 'smooth' });
      updateDots(toLogical(domIndex));
    }

    function goToNext() { smoothScrollToDom(state.currentDomIndex + 1); }
    function goToPrev() { smoothScrollToDom(state.currentDomIndex - 1); }
    function goToLogical(j) { smoothScrollToDom(state.realStart + j); }
    function advanceSlide() { goToNext(); }

    var ACTIVE_CARD_CLASS = 'oddit-section-flavor-carousel__card--active';
    function updateActiveCard(domIndex) {
      for (var i = 0; i < allSlides.length; i++) {
        if (i === domIndex) allSlides[i].classList.add(ACTIVE_CARD_CLASS);
        else allSlides[i].classList.remove(ACTIVE_CARD_CLASS);
      }
    }

    function updateDots(index) {
      if (!dots || !dots.length) return;
      for (var i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('oddit-section-flavor-carousel__dot--active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('oddit-section-flavor-carousel__dot--active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // If the resting position is on a clone, jump by one full set to the
    // equivalent real slide. Because clones are identical copies, the jump is
    // invisible. Returns true when it moved the scroll position.
    function normalizePosition() {
      if (!loop) { state.currentDomIndex = nearestDomIndex(); return false; }
      var dom = nearestDomIndex();
      if (dom < state.realStart) { setScrollInstant(dom + N); return true; }
      if (dom >= state.realStart + N) { setScrollInstant(dom - N); return true; }
      state.currentDomIndex = dom;
      return false;
    }

    function onScrollSettled() {
      var jumped = normalizePosition();
      state.currentIndex = toLogical(state.currentDomIndex);
      updateDots(state.currentIndex);
      updateActiveCard(state.currentDomIndex);
      // When we jumped, keep the programmatic flag set so the resulting
      // scroll event isn't misread as a user scroll; the next settle clears it.
      state.programmaticScroll = jumped;
    }

    function scheduleSettle() {
      if (state.settleTimer) clearTimeout(state.settleTimer);
      state.settleTimer = setTimeout(onScrollSettled, 120);
    }

    function onScroll() {
      if (!state.programmaticScroll && state.autoplay) {
        state.autoplay.disableAutoplayPermanently();
      }
      updateActiveCard(nearestDomIndex());
      scheduleSettle();
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    state.cleanup.push(function () { track.removeEventListener('scroll', onScroll); });

    // ---- Add to cart ----
    // Delegated so clones work too: sanitizeClone() strips data-add-to-cart, so
    // we match on the CTA class instead. The card's stretched link never fires
    // here — the CTA is stacked above it in CSS.
    function onCtaClick(e) {
      var btn = e.target.closest('.oddit-section-flavor-carousel__cta');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var drawer = window.OdditCartDrawer;
      if (!drawer || typeof drawer.addToCart !== 'function') {
        console.error('[oddit-flavor-carousel] cart drawer unavailable');
        return;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      drawer.addToCart(Number(variantId))
        .then(function () {
          if (typeof drawer.open === 'function') drawer.open();
        })
        .catch(function (err) {
          console.error('[oddit-flavor-carousel] addToCart failed:', err);
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    }
    track.addEventListener('click', onCtaClick);
    state.cleanup.push(function () { track.removeEventListener('click', onCtaClick); });

    // ---- Re-align to the current slide after a resize (widths change) ----
    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setScrollInstant(state.currentDomIndex); }, 150);
    }
    window.addEventListener('resize', onResize);
    state.cleanup.push(function () {
      window.removeEventListener('resize', onResize);
      if (resizeTimer) clearTimeout(resizeTimer);
    });

    // ---- Autoplay (RAF-based) ----
    function initAutoplay() {
      var autoplayEnabled = section.dataset.autoplay === 'true';
      if (!autoplayEnabled || !loop) return null;

      var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
      var intervalMs = speedSeconds * 1000;
      var rafId = null;
      var lastAdvance = performance.now();

      function disableAutoplayPermanently() {
        if (state.userControl) return;
        state.userControl = true;
        stopAutoplay();
      }

      function tick(now) {
        if (state.userControl) return;
        if (now - lastAdvance >= intervalMs) {
          advanceSlide();
          lastAdvance = now;
        }
        rafId = requestAnimationFrame(tick);
      }

      function startAutoplay() {
        if (state.userControl) return;
        if (rafId !== null) return;
        lastAdvance = performance.now();
        rafId = requestAnimationFrame(tick);
      }

      function stopAutoplay() {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotion.matches) {
        return {
          start: function () {},
          stop: function () {},
          destroy: function () {},
          disableAutoplayPermanently: function () {}
        };
      }

      function onVisibilityChange() {
        if (state.userControl) return;
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      }
      document.addEventListener('visibilitychange', onVisibilityChange);

      function onMouseEnter() { if (!state.userControl) stopAutoplay(); }
      function onMouseLeave() { if (!state.userControl) startAutoplay(); }
      track.addEventListener('mouseenter', onMouseEnter);
      track.addEventListener('mouseleave', onMouseLeave);

      track.addEventListener('focusin', disableAutoplayPermanently);
      track.addEventListener('touchstart', disableAutoplayPermanently, { passive: true });

      function onReducedMotionChange(e) {
        if (state.userControl) return;
        if (e.matches) stopAutoplay();
        else startAutoplay();
      }
      reducedMotion.addEventListener('change', onReducedMotionChange);

      startAutoplay();

      return {
        start: startAutoplay,
        stop: stopAutoplay,
        destroy: function () {
          stopAutoplay();
          document.removeEventListener('visibilitychange', onVisibilityChange);
          track.removeEventListener('mouseenter', onMouseEnter);
          track.removeEventListener('mouseleave', onMouseLeave);
          track.removeEventListener('focusin', disableAutoplayPermanently);
          track.removeEventListener('touchstart', disableAutoplayPermanently);
          reducedMotion.removeEventListener('change', onReducedMotionChange);
        },
        disableAutoplayPermanently: disableAutoplayPermanently
      };
    }

    // ---- Wire up navigation buttons ----
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToPrev();
        if (state.autoplay) state.autoplay.disableAutoplayPermanently();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToNext();
        if (state.autoplay) state.autoplay.disableAutoplayPermanently();
      });
    }

    if (dots && dots.length) {
      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            var index = parseInt(dot.getAttribute('data-slide-index'), 10) || 0;
            goToLogical(index);
            if (state.autoplay) state.autoplay.disableAutoplayPermanently();
          });
        }(dots[d]));
      }
    }

    // ---- Initial state ----
    if (loop) setScrollInstant(state.realStart);
    state.currentIndex = 0;
    updateDots(0);
    updateActiveCard(state.currentDomIndex);

    state.autoplay = initAutoplay();
    sectionState.set(sectionKey, state);
  }

  function destroySection(section) {
    if (!section) return;
    var key = section.id;
    var state = sectionState.get(key);
    if (!state) return;
    if (state.autoplay) state.autoplay.destroy();
    for (var i = 0; i < state.cleanup.length; i++) {
      try { state.cleanup[i](); } catch (e) {}
    }
    if (state.settleTimer) clearTimeout(state.settleTimer);

    var track = section.querySelector('.oddit-section-flavor-carousel__track');
    if (track) {
      var clones = track.querySelectorAll('[' + CLONE_ATTR + ']');
      for (var c = 0; c < clones.length; c++) {
        if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
      }
    }

    sectionState.delete(key);
    section.dataset.odditFcInit = '';
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
